import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import site from "../data/site";
import MetaBadge from "./MetaBadge";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/contact", label: "Contact" },
];

function useTheme() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return [theme, setTheme];
}

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [theme, setTheme] = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleTheme = () =>
    setTheme((current) => (current === "light" ? "dark" : "light"));

  return (
    <header className="site-header">
      <div className="topbar">
        <div className="container topbar__inner">
          <span className="topbar__trust">
            <i className="bi bi-patch-check-fill topbar__trust-icon" />
            Meta Technology Integration Partner · Digital Solutions
          </span>
          <div className="topbar__contact">
            <a
              href={site.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <i className="bi bi-whatsapp" /> {site.phone}
            </a>
            <a href={`mailto:${site.email}`}>
              <i className="bi bi-envelope" /> {site.email}
            </a>
            <span>
              <i className="bi bi-geo-alt" /> {site.location}
              <span className="topbar__flag" aria-label="Pakistan">
                🇵🇰
              </span>
            </span>
          </div>
        </div>
      </div>

      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="container navbar__inner">
          <div className="navbar__brand">
            <NavLink className="brand" to="/" aria-label={`${site.brand} home`}>
              <span className="brand__glyph">o</span>
              <span className="odinno-font brand__text">dinno</span>
            </NavLink>
            <MetaBadge className="navbar__meta" label="Meta API Solutions" />
          </div>

          <div className={`nav-links ${open ? "nav-links--open" : ""}`}>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                className={({ isActive }) =>
                  `nav-links__item ${isActive ? "nav-links__item--active" : ""}`
                }
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
            <div className="nav-links__socials nav-links__socials--mobile">
              {site.socials.map((social) => (
                <a
                  key={social.name}
                  className="social-btn"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={`bi bi-${social.name}`} />
                </a>
              ))}
            </div>
          </div>

          <div className="navbar__actions">
            <div className="nav-links__socials">
              {site.socials.map((social) => (
                <a
                  key={social.name}
                  className="social-btn"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={`bi bi-${social.name}`} />
                </a>
              ))}
            </div>
            <button
              className="theme-toggle"
              type="button"
              aria-label={`Switch to ${theme === "light" ? "dark" : "light"} theme`}
              onClick={toggleTheme}
            >
              <i className={`bi ${theme === "light" ? "bi-moon-stars-fill" : "bi-sun-fill"}`} />
            </button>
            <button
              className="nav-toggle"
              type="button"
              aria-label="Toggle navigation"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`bi ${open ? "bi-x-lg" : "bi-list"}`} />
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
